module.exports = __webpack_public_path__ + "static/media/lato-regular.108fe013.eot";